<template>
  <div>
    <div>
      <div class="title">
        <gl-sub-text>顧客属性</gl-sub-text>
      </div>
      <div class="content radio-buttons vertical">
        <md-radio v-model="_userCustomerAttributeSelection" value="not">
          未指定
        </md-radio>
        <md-radio v-model="_userCustomerAttributeSelection" value="order">
          <div class="input-inline input-inline--within-radio">
            <label class="input-inline__label">選択する</label>
            <md-field style="max-width: 200px">
              <md-select
                :value="inputName"
                @md-selected="$emit('update:inputName', $event)"
              >
                <md-option v-for="name in inputNames" :value="name" :key="name">
                  {{ name }}
                </md-option>
              </md-select>
            </md-field>
          </div>
        </md-radio>
        <md-radio v-model="_userCustomerAttributeSelection" value="upload">
          <div class="file-name">
            アップロードする
            <a href="#" @click.prevent="$refs.file.click()">
              {{ filename }}
            </a>
          </div>
        </md-radio>
        <input
          hidden
          ref="file"
          type="file"
          accept=".txt,.csv"
          multiple
          @change="setFiles($event.target.files)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'
export default {
  mixins: [ErrorReport],
  props: {
    userCustomerAttributeSelection: {
      type: String,
      default: 'not',
    },
    inputName: {
      type: String,
      default: '',
    },
    file: {
      type: File,
    },
  },
  data() {
    return {
      inputNames: [],
    }
  },
  watch: {
    userCustomerAttributeSelection(value) {
      this.$emit('update:userCustomerAttributeSelection', value)
    },
  },
  async mounted() {
    this.inputNames = await this.$repositories
      .get('userCustomerAttribute')
      .get()

    for (const name of this.inputNames) {
      if (this.inputName === name) {
        return
      }
    }

    this.$emit('update:inputName', this.inputNames[0])
  },
  computed: {
    filename() {
      if (!this.file) {
        return 'ファイルが選択されていません'
      }
      return this.file.name
    },
    _userCustomerAttributeSelection: {
      get() {
        return this.userCustomerAttributeSelection
      },
      set(newVal) {
        this.$emit('update:userCustomerAttributeSelection', newVal)
      },
    },
    _inputName: {
      get() {
        return this.inputName
      },
      set(newVal) {
        this.$emit('update:inputName', newVal)
      },
    },
    errors() {
      const errors = []

      if (this.userCustomerAttributeSelection === 'order' && !this.inputName) {
        errors.push('名称を選択してください')
      }

      if (this.userCustomerAttributeSelection === 'upload' && !this.file) {
        errors.push('顧客属性ファイルを選択してください')
      }

      return errors
    },
  },
  methods: {
    setFiles(files) {
      if (files.length === 0) {
        return
      }
      this.$emit('update:file', files[0])
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  margin-top: var(--spacing-medium);
}
.radio-buttons {
  display: flex;

  &.vertical {
    flex-direction: column;
  }
}
</style>
